import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Sprint 1 S2 — Sentry SDK (conditional). Initialize before React mounts so
// any runtime error in App, including in early lifecycle / render, is captured.
// If REACT_APP_SENTRY_DSN is unset (e.g. dev or pre-Sentry-signup), this is a
// no-op — no errors, no noise.
const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
if (SENTRY_DSN) {
  // Static ES import keeps Sentry tree-shaken when DSN is absent (the
  // `if (SENTRY_DSN)` guard short-circuits init).
  // eslint-disable-next-line global-require
  const Sentry = require("@sentry/react");
  try {
    Sentry.init({
      dsn: SENTRY_DSN,
      environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || "production",
      // Conservative: only capture errors, not every page load.
      tracesSampleRate: 0.0,
      replaysSessionSampleRate: 0.0,
      replaysOnErrorSampleRate: 0.0,
      // Don't capture noisy framework warnings — only real errors.
      ignoreErrors: [
        "ResizeObserver loop limit exceeded",
        "Non-Error promise rejection captured",
      ],
    });
  } catch (e) {
    // Sentry must never break the app. Fall through.
    // eslint-disable-next-line no-console
    console.warn("Sentry init failed:", e);
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
